import { createAction } from '@hip/helpers';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["VALIDATE_AUTH_SUCCESS"] = "@hip/colleague-designs/auth/VALIDATE_AUTH_SUCCESS";
    ActionTypes["VALIDATE_AUTH_FAIL"] = "@hip/colleague-designs/auth/VALIDATE_AUTH_FAIL";
    ActionTypes["MAKE_LOGIN"] = "@hip/colleague-designs/auth/MAKE_LOGIN";
    ActionTypes["MAKE_LOGIN_SUCCESS"] = "@hip/colleague-designs/auth/MAKE_LOGIN_SUCCESS";
    ActionTypes["MAKE_LOGIN_FAIL"] = "@hip/colleague-designs/auth/MAKE_LOGIN_FAIL";
    ActionTypes["RESET_LOGIN_ERROR"] = "@hip/colleague-designs/auth/RESET_LOGIN_ERROR";
})(ActionTypes || (ActionTypes = {}));
export var actions = {
    validateAuthSuccess: function (payload) {
        return createAction(ActionTypes.VALIDATE_AUTH_SUCCESS, payload);
    },
    validateAuthFail: function () { return createAction(ActionTypes.VALIDATE_AUTH_FAIL); },
    makeLogin: function (payload) {
        return createAction(ActionTypes.MAKE_LOGIN, payload);
    },
    makeLoginSuccess: function (payload) {
        return createAction(ActionTypes.MAKE_LOGIN_SUCCESS, payload);
    },
    makeLoginFail: function (payload) {
        return createAction(ActionTypes.MAKE_LOGIN_FAIL, payload);
    },
    resetLoginError: function () { return createAction(ActionTypes.RESET_LOGIN_ERROR); },
};
